export default "https://statics.cloudfastin.top/static/v1.27.25.1/store/images/downward1.png?23cec50947066a50734980de1ad4e013";